<template>
  <div class="text-center">
    <v-dialog v-model="loading.showing" persistent width="300">
      <v-card color="rgb(17, 65, 206)" dark>
        <v-card-text>
          <h4 class="ma-1">
            {{ loading.text }}
          </h4>
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Loading",
  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>
